import React from 'react';
import { Navigate } from 'react-router-dom';
import { useVendorContext } from '../../context/VendorContext';

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const { vendor, loading } = useVendorContext();
  const token = localStorage.getItem("jwtToken");

  // Don't render anything until loading is done
  if (loading) return null; // Or show spinner

  // Redirect if not authenticated
  if (!token || !vendor) return <Navigate to="/login" replace />;

  return children;
};

export default PrivateRoute;
